import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_FILES_DELIVERY_POINT_RESET = 'DELETE_FILES_DELIVERY_POINT_RESET';
export const DELETE_FILES_DELIVERY_POINT_LOADING = 'DELETE_FILES_DELIVERY_POINT_LOADING';
export const DELETE_FILES_DELIVERY_POINT_SUCCESS = 'DELETE_FILES_DELIVERY_POINT_SUCCESS';
export const DELETE_FILES_DELIVERY_POINT_REJECT = 'DELETE_FILES_DELIVERY_POINT_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteFilesDeliveryPointReset = () => ({ type: DELETE_FILES_DELIVERY_POINT_RESET });
export const deleteFilesDeliveryPointLoading = () => ({ type: DELETE_FILES_DELIVERY_POINT_LOADING });
export const deleteFilesDeliveryPointSuccess = (payload) => ({ type: DELETE_FILES_DELIVERY_POINT_SUCCESS, payload });
export const deleteFilesDeliveryPointReject = (payload) => ({ type: DELETE_FILES_DELIVERY_POINT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteFilesDeliveryPointRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/api/Route/DeleteRouteUploadFile/${data}`, options);
};